import { ODataQueryController } from "../../../controllers";
import { ComponentBase } from "../../_ComponentBase";

/**
 * Shows a list of taxcards
 * @example
 * ```html
 * <salaxy-taxcard-list ></salaxy-taxcard-list>
 * ```
 */
export class TaxcardList extends ComponentBase {
    /**
     * The following component properties (attributes in HTML) are bound to the Controller.
     * For detailed functionality, refer to [controller](#controller) implementation.
     */
    public bindings = {
      /**
       * Function that is called when user selects an item in the list.
       * Note that the event is called only in the selections (single and multi).
       * Function has the following locals: value: true/false, item: the last selected/unselected item, allItems: Array of all currently selected items.
       * @example <salaxy-taxcard-list mode="select" options="$ctrl.logic.options" on-list-select="$ctrl.logic.doSomething(item.id)"></salaxy-taxcard-list>
       */
      onListSelect: "&",

      /** Selected items for the case where the list is used as a select list (as opposed to link list). */
      selectedItems: "<",

      /** Type of the view. Currently supports "default", "panel" and "select" */
      mode: "@",

      /** OData query options */
      options: "<",
    };

    /** Uses the ODataQueryController */
    public controller = ODataQueryController;

    /** The default template for the component. */
    public defaultTemplate = "salaxy-components/worker/taxcard/TaxcardList.html";

}
